const autoNgTemplateLoaderTemplate1 = require('./sidebar-section.html');

export const sidebarSection = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  transclude: true,
  bindings: {
    title: '@',
  },
};
